import DataTable from "primevue/datatable";
import Column from "primevue/column";
import travellaHeader from "../TravellaHeader";
import SettingsService from "../../shared/settings/settings.service.js";

export default {
    name: "konkursHotOferta",
    components: {
        DataTable,
        Column,
        travellaHeader
    },
    props: [],
    data: function() {
        return {
            dane: []
        };
    },
    computed: {},
    mounted() {
        this.wczytajDane();
        this.$nextTick(() => {
            travellaHeader.loadHeader();
        });
    },
    methods: {
        wczytajDane() {
            this.$http
                .get(`${SettingsService.hotOfertaApi}`)
                .then((response) => {
                    this.dane = response.body;
                })
                .catch((error) => {
                    // eslint-disable-next-line
                    console.log(error);
                });
        }
    }
};
